const viewport = (function() {

  function isSm() {
    return window.matchMedia('(max-width: 600px)').matches;
  }

  function isMd() {
    return window.matchMedia('(max-width: 1024px) and (min-width: 600.01px)').matches;
  }

  function isLg() {
    return window.matchMedia('(min-width: 1024.01px)').matches;
  }

  function isMdBelow() {
    return window.matchMedia('(max-width: 1024px)').matches;
  }

  function isMdAbove() {
    return window.matchMedia('(min-width: 600.01px)').matches;
  }

  function isOldSm() {
    return window.matchMedia('(max-width: 768px').matches;
  }

  function getCurrent() {
    if (window.matchMedia('(max-width: 600px)').matches) return 'sm';
    if (window.matchMedia('(max-width: 1024px) and (min-width: 600.01px)').matches) return 'md';
    if (window.matchMedia('(min-width: 1024.01px)').matches) return 'lg';

    return null;
  }

  return {
    isSm,
    isMd,
    isLg,
    isMdBelow,
    isMdAbove,
    isOldSm,
    getCurrent
  }
}());

export default viewport;